import axios from "axios";

export default {
    async getUser({ commit }) {
        return await axios.get('/api/auth/user-state', { withCredentials: true })
            .then(res => {
                commit('setUser', res.data.user);
                return res.data.user;
            })
            .catch(() => {
                return null;
            })
    },

    retrieveToken(_, credentials) {
        return new Promise((resolve, reject) => {
            axios.post('/api/auth/login', credentials, { withCredentials: true })
                .then((response) => {
                    localStorage.setItem('username', response.data.username);
                    localStorage.setItem('firstname', response.data.firstname);
                    localStorage.setItem('surname', response.data.surname);
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                })
        })
    },

    destroyToken(_, credentials) {
        return axios.post('/api/auth/sessionlogout', credentials, { withCredentials: true });
    },

    retrieveNewCompanyToken(_, params) {
        return axios.post("/api/auth/retrievetoken", params, { withCredentials: true });
    },

    setUserInfo({ commit }, user) {
        commit('setUser', user);
    },

    getCompanySector() {
        return axios.get('/api/company/getcompanysector', { withCredentials: true })
    },

    getUserCompanyInfo() {
        return axios.get("/api/company/getusercompanyinfo", { withCredentials: true });
    },

    sendResetPassword(_, params){
        return axios.post('/api/auth/resetpassword', params, { withCredentials: true })
    },

    setAdminPanel({ commit }, bool) {
        commit("setAdminPanel", bool);
    },

    setCompanyLicence({ commit }, licence) {
        commit("SET_COMPANY_LICENCE", licence);
    },

    setSelectedReportLanguages({ commit }, reportLanguages) {
        commit('SET_SELECTED_REPORT_LANGUAGES', reportLanguages);
    },

    setNavbarOpen({ commit }, bool) {
        commit('SET_NAVBAR_OPEN', bool);
    },

    setQueuedJobs({ commit }, jobs) {
        commit('SET_QUEUED_JOBS', jobs);
    },

    setFulfilledJobs({ commit }, jobs) {
        commit('SET_FULFILLED_JOBS', jobs);
    },

    setAppState({ commit }, state) {
        commit('SET_APP_STATE', state);
    },

    //#region NOTIFICATIONS

    getNotificationCounts() {
        return axios.get('/api/notification/notification-counts', {withCredentials: true});
    },

    getNotifications(_, params) {
        return axios.get(`/api/notification/notifications/${params.type}/${params.is_read}`, {withCredentials: true});
    },

    markNotification(_, params) {
        return axios.get(`/api/notification/mark-notification/${params.type}/${params.id}`, {withCredentials: true});
    },

    //#endregion NOTIFICATIONS
}